import {
    LineChart as RechartsLineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Legend,
    LabelList,
  } from 'recharts';
import AngledAxisTick from '../AngledAxisTick';
import AnalyticsEmptyState from "../../dashboard/AnalyticsEmptyState";

// Het gemiddelde bij elk punt, met een decimale komma (2.5 → '2,5', 4 → '4').
// Zonder getallen was het gemiddelde naast de meter van een andere periode
// nergens af te lezen (testronde 2026-10-28, B3).
// AI-CONTEXT: See docs/features/deep-analysis-period.md
const pointLabel = (value) => (Number.isFinite(value) ? String(Math.round(value * 10) / 10).replace('.', ',') : '');

const ScaleDevelopmentLineChart = ({ groupedData, color, totalResponses, graphColor }) => {
  if (!groupedData || groupedData.length === 0) {
    return <AnalyticsEmptyState />;
  }

  // Transform groupedData into the line chart format
  const lineData = groupedData.map((item) => ({
    name: item.moment, // Use 'moment' as the x-axis label
    value: parseFloat(item.average), // Convert 'average' to a number for the y-axis
  }));

 // Custom Tooltip
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const { name, value } = payload[0].payload; // Get current data point
      return (
        <div
          style={{
            backgroundColor: 'white',
            border: '1px solid #ccc',
            borderRadius: '5px',
            padding: '10px',
          }}
        >
          <p style={{ margin: 0, fontWeight: 'bold' }}>{name}</p>
          <p style={{ margin: 0 }}>{`Gemiddelde score: ${value}`}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <div
      className="scale-development-chart"
    >
      <ResponsiveContainer width="100%" height="100%">
        <RechartsLineChart data={lineData} margin={{ top: 20, right: 20, left: 20, bottom: 5 }}>
          <XAxis
          dataKey="name"
          tick={<AngledAxisTick fill={graphColor || undefined} />}
          interval={0}
          height={70}
          axisLine={false}
          tickLine={false}
          stroke={graphColor || 'black'} />
          <YAxis
          domain={[0, 'auto']}
          tick={{ fontSize: 12, fill: graphColor || undefined }}
          axisLine={false}
          tickLine={false}
          stroke={graphColor || 'black'} />
          <Tooltip content={<CustomTooltip />} />
          <Line type="monotone" dataKey="value" stroke={color} strokeWidth={2} dot={{ r: 5 }}>
            <LabelList dataKey="value" position="top" offset={10} formatter={pointLabel} className="scale-development-point-label" />
          </Line>
        </RechartsLineChart>
      </ResponsiveContainer>
    </div>
  );
}

export default ScaleDevelopmentLineChart